var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { GET_PERMISSIONS, CLEAR_PERMISSIONS } from './constants';
import services from '../../services';
import { PermissionHandler } from './serviceHandler';
var permissionHandler = new PermissionHandler();
var PermissionService = services.PermissionService;
export var getPermissions = function (target) { return function (dispatch) {
    dispatch({ type: GET_PERMISSIONS, target: target });
}; };
export var getPermissionsByTargets = function (targets) { return function (dispatch) {
    permissionHandler.getPermissions(dispatch, targets);
}; };
export var clearPermissions = function () { return function (dispatch) {
    dispatch({ type: CLEAR_PERMISSIONS });
}; };
export var loadPermissionItems = function (app) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var permissionItems, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'PERMISSION_ITEMS_LOAD_REQUEST' });
                return [4 /*yield*/, PermissionService.getPermissionItems(app)];
            case 1:
                permissionItems = (_a.sent()).objects;
                dispatch({
                    type: 'PERMISSION_ITEMS_LOAD_SUCCESS',
                    permissionItems: permissionItems,
                });
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                console.error(err_1);
                dispatch({
                    type: 'PERMISSION_ITEMS_LOAD_FAILURE',
                    err: err_1,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var loadTargetPermissions = function (target, appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, targetPermissions, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    dispatch({ type: 'TARGET_PERMISSION_LOAD_REQUEST' });
                    return [4 /*yield*/, PermissionService.getTargetPermissions(target, appId)];
                case 1:
                    _a = (_b.sent()).objects, targetPermissions = _a === void 0 ? [] : _a;
                    dispatch({
                        type: 'TARGET_PERMISSION_LOAD_SUCCESS',
                        targetPermissions: targetPermissions,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _b.sent();
                    dispatch({
                        type: 'TARGET_PERMISSION_LOAD_FAILURE',
                        err: err_2,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var loadAppGroups = function (app) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, objects, appGroups, err_3;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                dispatch({ type: 'APP_GROUPS_LOAD_REQUEST' });
                return [4 /*yield*/, PermissionService.getGroups(app)];
            case 1:
                _a = (_b.sent()).objects, objects = _a === void 0 ? [] : _a;
                appGroups = objects.map(function (_a) {
                    var id = _a.id, label = _a.label, name = _a.name, type = _a.type;
                    return ({
                        id: id,
                        label: label,
                        name: name,
                        type: type,
                    });
                });
                dispatch({
                    type: 'APP_GROUPS_LOAD_SUCCESS',
                    appGroups: appGroups,
                });
                return [3 /*break*/, 3];
            case 2:
                err_3 = _b.sent();
                dispatch({
                    type: 'APP_GROUPS_LOAD_FAILURE',
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
// For editing the target permissions table in-place
export var editTargetPermissions = function (groupId, action, checked) {
    return function (dispatch) {
        dispatch({ type: 'TARGET_PERMISSIONS_EDIT', groupId: groupId, action: action, checked: checked });
    };
};
// For editing the target permissions table in-place by clicking on action column header
export var editTargetPermissionsMultiple = function (action, checked) {
    return function (dispatch) {
        dispatch({ type: 'TARGET_PERMISSIONS_MULTI_EDIT', action: action, checked: checked });
    };
};
// For adding a new permission to the target permission table using the new permission modal
export var addTargetPermission = function (newPerm) {
    return function (dispatch) {
        dispatch({ type: 'TARGET_PERMISSION_ADD', newPerm: newPerm });
    };
};
export var undoTargetPermissions = function () { return function (dispatch) {
    dispatch({ type: 'TARGET_PERMISSIONS_UNDO' });
}; };
export var patchTargetPermissions = function (target, patches, newPerms, appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, targetPermissions, err_4;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    dispatch({ type: 'TARGET_PERMISSIONS_PATCH_REQUEST' });
                    return [4 /*yield*/, PermissionService.patchTargetPermissions(target, __spreadArray(__spreadArray([], patches, true), newPerms.map(function (perm) { return (__assign(__assign(__assign(__assign(__assign({ groupId: perm.groupId }, (perm.create && {
                            create: 'grant',
                        })), (perm.read && {
                            read: 'grant',
                        })), (perm.update && {
                            update: 'grant',
                        })), (perm.delete && {
                            delete: 'grant',
                        })), (perm.permission && {
                            permission: 'grant',
                        }))); }), true), appId)];
                case 1:
                    _a = (_b.sent()).objects, targetPermissions = _a === void 0 ? [] : _a;
                    dispatch({
                        type: 'TARGET_PERMISSIONS_PATCH_SUCCESS',
                        targetPermissions: targetPermissions,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_4 = _b.sent();
                    dispatch({
                        type: 'TARGET_PERMISSIONS_PATCH_FAILURE',
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var loadPermissionRoles = function (app) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, objects, permissionRoles, err_5;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                dispatch({ type: 'PERMISSION_ROLES_LOAD_REQUEST' });
                return [4 /*yield*/, PermissionService.getPermissionRoles(app)];
            case 1:
                _a = (_b.sent()).objects, objects = _a === void 0 ? [] : _a;
                permissionRoles = objects.map(function (_a) {
                    var id = _a.id, label = _a.label, name = _a.name, type = _a.type;
                    return ({
                        id: id,
                        label: label,
                        name: name,
                        type: type,
                    });
                });
                dispatch({
                    type: 'PERMISSION_ROLES_LOAD_SUCCESS',
                    permissionRoles: permissionRoles,
                });
                return [3 /*break*/, 3];
            case 2:
                err_5 = _b.sent();
                dispatch({
                    type: 'PERMISSION_ROLES_LOAD_FAILURE',
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var loadRolePermissions = function (app, group) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, rolePermissions, err_6;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    dispatch({ type: 'ROLE_PERMISSIONS_LOAD_REQUEST' });
                    return [4 /*yield*/, PermissionService.getRolePermissions(app, group)];
                case 1:
                    _a = (_b.sent()).objects, rolePermissions = _a === void 0 ? [] : _a;
                    dispatch({
                        type: 'ROLE_PERMISSIONS_LOAD_SUCCESS',
                        roleId: group,
                        rolePermissions: rolePermissions,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_6 = _b.sent();
                    dispatch({
                        type: 'ROLE_PERMISSIONS_LOAD_FAILURE',
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
// For editing the role permissions table in-place
export var editRolePermissions = function (target, action, checked) {
    return function (dispatch) {
        dispatch({ type: 'ROLE_PERMISSIONS_EDIT', target: target, action: action, checked: checked });
    };
};
// For editing the role permissions table in-place by clicking on action column header
export var editRolePermissionsMultiple = function (action, checked) {
    return function (dispatch) {
        dispatch({ type: 'ROLE_PERMISSIONS_MULTI_EDIT', action: action, checked: checked });
    };
};
export var undoRolePermissions = function () { return function (dispatch) {
    dispatch({ type: 'ROLE_PERMISSIONS_UNDO' });
}; };
export var patchRolePermissions = function (app, group, patches) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, rolePermissions, err_7;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    dispatch({ type: 'ROLE_PERMISSIONS_PATCH_REQUEST' });
                    return [4 /*yield*/, PermissionService.patchRolePermissions(app, group, patches)];
                case 1:
                    _a = (_b.sent()).objects, rolePermissions = _a === void 0 ? [] : _a;
                    dispatch({
                        type: 'ROLE_PERMISSIONS_PATCH_SUCCESS',
                        rolePermissions: rolePermissions,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_7 = _b.sent();
                    dispatch({
                        type: 'ROLE_PERMISSIONS_PATCH_FAILURE',
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
